import { render, staticRenderFns } from "./checkWasteLabels.vue?vue&type=template&id=155c4b7b&scoped=true&"
import script from "./checkWasteLabels.vue?vue&type=script&lang=js&"
export * from "./checkWasteLabels.vue?vue&type=script&lang=js&"
import style0 from "./checkWasteLabels.vue?vue&type=style&index=0&id=155c4b7b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155c4b7b",
  null
  
)

component.options.__file = "checkWasteLabels.vue"
export default component.exports